var _path, _circle, _mask, _rect, _line, _mask2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLisLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10561 14.3876C4.68562 13.699 4.71394 12.8847 4.68562 12.1638C4.63495 10.8743 4.90308 9.59218 5.46626 8.43106C6.02944 7.26994 6.78493 6.30517 6.97633 6.11377L9.27309 7.83634C8.6989 8.41053 8.38103 8.92965 8.02168 9.67053C7.66233 10.4114 7.49125 11.2295 7.52358 12.0523C7.5559 12.8751 7.79065 13.6772 8.20703 14.3876C8.6234 15.098 9.20855 15.6947 9.91064 16.125C10.6127 16.5552 11.4101 16.8056 12.2321 16.8541C13.0541 16.9026 13.8754 16.7476 14.6231 16.4029C15.3709 16.0581 16.0222 15.5343 16.5191 14.8777C17.0161 14.2212 17.183 13.8174 17.3118 13.0041L20.2775 13.0832C20.0756 14.3578 19.5625 15.563 18.7837 16.5919C18.0048 17.6209 16.9842 18.4418 15.8122 18.9821C14.6403 19.5224 13.3531 19.7653 12.0649 19.6893C10.7766 19.6134 9.527 19.2209 8.42667 18.5466C8.10979 18.3524 7.80811 18.1366 7.52358 17.9011",
    stroke: "white",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.2107,
    cy: 16.2582,
    r: 1.54676,
    stroke: "white",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_9787_82392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.13013,
    width: 11.4838,
    height: 4.05082,
    rx: 1,
    transform: "rotate(35.7158 5.13013 0)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.13013,
    width: 11.4838,
    height: 4.05082,
    rx: 1,
    transform: "rotate(35.7158 5.13013 0)",
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_9787_82392)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.015,
    y1: 12.4458,
    x2: 22.2881,
    y2: 12.4458,
    stroke: "white",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9787_82392",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 21.5C2 20.6716 2.67157 20 3.5 20H20.5C21.3284 20 22 20.6716 22 21.5H2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.5H20.5V18.5H3.5V21.5ZM22 20H2V23H22V20ZM20.5 21.5H23.5C23.5 19.8431 22.1569 18.5 20.5 18.5V21.5ZM3.5 18.5C1.84315 18.5 0.5 19.8431 0.5 21.5H3.5H3.5V18.5Z",
    fill: "white",
    mask: "url(#path-5-inside-2_9787_82392)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17L5 20",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLisLight);
export default __webpack_public_path__ + "static/media/LIS_light.5b55e679.svg";
export { ForwardRef as ReactComponent };